import NodeController05ABI from "@abi/NodeController05";
import type { Address } from "viem";
import { useReadContract } from "wagmi";
import useContract from "./useContract";
const useClaimTaxQuote = (nodes: number[]) => {
	const { nodeController05Contract } = useContract();

	// Makes a call to a specific method of a specific contract and returns the value or an error if present.
	// The hook will cause the component to refresh when a new block is mined and the return value changes.
	const { data } = useReadContract({
		abi: NodeController05ABI,
		address: nodeController05Contract.address as Address,
		args: [nodes.map((num) => BigInt(num?.toString()))],
		functionName: "getClaimTaxQuote",
	}) ?? { value: [] };

	return data?.toString() ?? "0";
};

export default useClaimTaxQuote;
